<div class="flex h-full min-h-0 flex-col overflow-hidden bg-surface-50 dark:bg-surface-900">
  <header
    class="shrink-0 border-b border-surface-200 dark:border-surface-700 bg-white dark:bg-surface-800 px-6 py-4"
  >
    <h1 class="text-xl font-semibold text-surface-900 dark:text-surface-0 m-0">Administration</h1>
    <p class="text-sm text-surface-600 dark:text-surface-400 m-0 mt-1">
      BrightNav operator tools. Sections below are registered by feature libraries via the admin contract.
    </p>
  </header>
  <div class="bn-admin-scroll-region flex min-h-0 flex-1 flex-col">
    <nav aria-label="Admin breadcrumb" class="mb-3 shrink-0 px-6 pt-3">
      <p-breadcrumb [model]="adminBreadcrumbs()" styleClass="border-0 bg-transparent p-0 text-sm" />
    </nav>
    <bds-scroll-region
      class="min-h-0 flex-1"
      height="100%"
      ariaLabel="Administration content"
    >
      <div class="px-6 pb-6">
        <router-outlet />
      </div>
    </bds-scroll-region>
  </div>
</div>
